// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcq_a bhb_qn bhb_qo bhb_ua bhb_cy bhb_ty bhb_gm bhb_ka"};